export const MINIMAL_DIFF_WIDTH = 32;
